var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { faTimes, faTrash, faUsers } from "@fortawesome/pro-regular-svg-icons";
import { faCheckCircle, faExclamationTriangle, faTrashAlt } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TableView } from "@yodlee/common-components";
import { NotificationUtils } from "@yodlee/common-components/dist/utilities";
import { Button, Col, Icon, Modal, Result, Row, Spin, Tooltip, Typography } from "antd";
import React from "react";
import { LabelConfigs } from "../../../configurations";
import { DataUtils } from "../../../utilities";
import InsightsUserForm from "../insights-user-form";
import MediaQuery from "react-responsive";
import { PermissionEnums, ResponsiveEnums } from "@yodlee/common-components/dist/types/enumerations";
var initialPagination = {
    defaultPageSize: 2,
    defaultCurrent: 1,
    pageSizeOptions: ["2", "4", "6"],
    showSizeChanger: true,
    showQuickJumper: true,
    current: 1,
    pageSize: 2
};
var InsightUserList = /** @class */ (function (_super) {
    __extends(InsightUserList, _super);
    function InsightUserList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            pagination: initialPagination,
            usersData: [],
            showCreateModal: false,
            selectedRoleId: "",
            disableDelete: false,
            selectedRoleName: ""
        };
        _this.componentDidMount = function () {
            var authentication = _this.props.authentication;
            DataUtils.onload(authentication).get(undefined, false).then(function (onload) {
                _this.setState({ onload: onload });
                DataUtils.permission(authentication).get(onload.user.id).then(function (permissions) { return _this.setState({ permissions: permissions }); });
            });
            _this.getInsightUsers();
        };
        _this.getInsightUsers = function () {
            var authentication = _this.props.authentication;
            DataUtils.insightsUsers(authentication)
                .get()
                .then(function (data) {
                var loadedData = [];
                data.forEach(function (element) {
                    var _a, _b;
                    var children = element.users.normal.length > 0 ?
                        (element.users.normal || []).map(function (user) { return ({
                            role: {
                                id: user.id,
                                name: user.name
                            },
                            users: [user.status],
                            actions: {
                                roleId: element.role.id,
                                roleName: element.role.name,
                                user: user.name
                            }
                        }); }) : [];
                    var supportUsers = [];
                    (_b = (_a = element === null || element === void 0 ? void 0 : element.users) === null || _a === void 0 ? void 0 : _a.support) === null || _b === void 0 ? void 0 : _b.map(function (user) {
                        supportUsers.push(user.name);
                    });
                    loadedData.push({
                        role: {
                            id: element.role.id,
                            name: element.role.name
                        },
                        actions: {
                            roleId: element.role.id,
                            roleName: element.role.name
                        },
                        users: supportUsers,
                        children: children.length > 0 ? children : undefined
                    });
                });
                _this.setState({ usersData: loadedData });
            });
        };
        _this.onCloseModal = function () {
            _this.setState({ showCreateModal: false });
            _this.getInsightUsers();
        };
        _this.onDelete = function (roleName, roleId, username) {
            var authentication = _this.props.authentication;
            _this.setState({ disableDelete: true });
            var filter = { roleId: roleId };
            var newFilters = undefined;
            if (username) {
                newFilters = {
                    user: username
                };
            }
            Modal.confirm({
                keyboard: false,
                title: React.createElement(Typography.Title, { className: "color-blue-5", level: 2 },
                    username ?
                        React.createElement(React.Fragment, null,
                            username,
                            " user will be deleted") :
                        React.createElement(React.Fragment, null,
                            "All users of the role ",
                            roleName,
                            " will be deleted"),
                    React.createElement("br", null)),
                icon: null,
                width: "450px",
                okText: "Delete",
                cancelButtonProps: { type: "danger" },
                onOk: function () {
                    DataUtils.insightsUsers(authentication)
                        .delete(__assign(__assign({}, filter), newFilters))
                        .then(function () {
                        _this.getInsightUsers();
                        NotificationUtils.success(React.createElement(React.Fragment, null, "Success"), React.createElement(React.Fragment, null,
                            username ? 'User' : 'Users',
                            " deleted successfully."));
                    }).catch(function (err) {
                        NotificationUtils.error(React.createElement(React.Fragment, null, "Failed"), React.createElement(React.Fragment, null, err));
                    }).finally(function () {
                        _this.setState({ disableDelete: false });
                    });
                }
            });
        };
        _this.render = function () {
            var _a = _this.state, usersData = _a.usersData, showCreateModal = _a.showCreateModal, selectedRoleId = _a.selectedRoleId, selectedRoleName = _a.selectedRoleName, permissions = _a.permissions, onload = _a.onload;
            var createModal = React.createElement(Modal, { destroyOnClose: true, className: "no-padding-modal", width: "50%", style: { top: "36px" }, footer: null, visible: showCreateModal, onCancel: _this.onCloseModal, closable: true, title: null, closeIcon: React.createElement(Icon, { onClick: _this.onCloseModal, component: function () { return React.createElement(FontAwesomeIcon, { icon: faTimes }); } }) }, React.createElement(InsightsUserForm, { onCancel: _this.onCloseModal, onCreate: _this.onCloseModal, roleId: selectedRoleId, roleName: selectedRoleName, authentication: _this.props.authentication }));
            var columns = [
                {
                    title: LabelConfigs.ROLE,
                    key: "role",
                    dataIndex: "role.name",
                    ellipsis: true,
                    width: 220,
                    minWidth: 140
                },
                {
                    title: LabelConfigs.SUPPORT_USER,
                    key: "supportUser",
                    dataIndex: "users",
                    ellipsis: true,
                    width: 220,
                    minWidth: 140,
                    render: function (items) {
                        var users = items.slice(0, 5);
                        var isLoadMore = items.length > 5;
                        var toolTipTitle = React.createElement(React.Fragment, null, items.map(function (item) {
                            return React.createElement(React.Fragment, null,
                                item,
                                React.createElement("br", null));
                        }));
                        return (React.createElement(React.Fragment, null,
                            React.createElement(Tooltip, { title: toolTipTitle, placement: "rightTop" }, users.map(function (item) {
                                return React.createElement(React.Fragment, null, item === 'Active' ?
                                    React.createElement(React.Fragment, null,
                                        React.createElement(Icon, { className: "font-size-lg", component: function () { return React.createElement(FontAwesomeIcon, { icon: faCheckCircle, className: "color-green" }); } }),
                                        React.createElement("span", { className: "margin-left-xs" }),
                                        item) : item === 'Expired' ?
                                    React.createElement(React.Fragment, null,
                                        React.createElement(Icon, { className: "font-size-lg", component: function () { return React.createElement(FontAwesomeIcon, { icon: faExclamationTriangle, className: "color-yellow" }); } }),
                                        React.createElement("span", { className: "margin-left-xs" }),
                                        item) :
                                    React.createElement(React.Fragment, null,
                                        React.createElement("span", { className: 'color-blue-5 cursor-pointer' }, item),
                                        React.createElement("br", null)));
                            })),
                            isLoadMore && React.createElement("p", null, "...")));
                    }
                },
                {
                    title: LabelConfigs.ACTIONS,
                    key: "role",
                    dataIndex: "actions",
                    ellipsis: true,
                    width: 220,
                    minWidth: 140,
                    render: function (actions) {
                        return (React.createElement(React.Fragment, null, (actions === null || actions === void 0 ? void 0 : actions.user) === undefined ?
                            React.createElement(React.Fragment, null,
                                React.createElement(Button, { type: "default", onClick: function () { _this.setState({ showCreateModal: true, selectedRoleId: actions === null || actions === void 0 ? void 0 : actions.roleId, selectedRoleName: actions === null || actions === void 0 ? void 0 : actions.roleName }); } },
                                    React.createElement(Icon, { className: "font-size-lg", component: function () { return React.createElement(FontAwesomeIcon, { icon: faUsers }); } }),
                                    "Create users"),
                                React.createElement("span", { className: "margin-left-xs" }),
                                React.createElement(Button, { type: "danger", onClick: function () { _this.onDelete(actions === null || actions === void 0 ? void 0 : actions.roleName, actions.roleId); } },
                                    React.createElement(Icon, { className: "font-size-lg", component: function () { return React.createElement(FontAwesomeIcon, { icon: faTrash }); } }),
                                    "Delete all users")) :
                            React.createElement(React.Fragment, null,
                                React.createElement("div", { style: { marginTop: "0px", textAlign: "left" } },
                                    React.createElement(Icon, { className: "font-size-lg", onClick: function () { return _this.onDelete(actions.roleName, actions.roleId, actions.user); }, component: function () { return React.createElement(FontAwesomeIcon, { icon: faTrashAlt, style: { color: "red" } }); } })))));
                    }
                }
            ];
            var viewPermission = permissions === null || permissions === void 0 ? void 0 : permissions.find(function (permission) { return permission.id === PermissionEnums.TRIALS.CONSUMER_INSIGHTS; });
            return (usersData && usersData.length > 0 && onload && permissions ?
                viewPermission ?
                    React.createElement(MediaQuery, { minWidth: ResponsiveEnums.SCREEN_SIZE.MD, minDeviceWidth: ResponsiveEnums.SCREEN_SIZE.MD }, function (matches) {
                        return React.createElement(React.Fragment, null,
                            createModal,
                            React.createElement(TableView, { columns: columns, getRowKey: function (data) { var _a; return (_a = data === null || data === void 0 ? void 0 : data.role) === null || _a === void 0 ? void 0 : _a.id.toString(); }, data: usersData || [], tableSetting: false, pagination: false }));
                    }) :
                    React.createElement(Result, { status: 403, title: "403", subTitle: "Sorry, you are not authorized." }) :
                React.createElement(Row, { type: "flex", style: { height: "80vh" }, justify: "center", align: "middle" },
                    React.createElement(Col, null,
                        React.createElement(Spin, { size: "large", indicator: React.createElement(Icon, { type: "loading" }) }))));
        };
        return _this;
    }
    return InsightUserList;
}(React.Component));
export default InsightUserList;
//# sourceMappingURL=index.js.map